import {
  convertLoadedHeader,
  convertSaveHeader,
  generateUpdatedImagePengecekanMobil,
} from "../../utils/editorHelpers";

// Everything about the header of the audit (the auditkendaraan) and what is loaded with it:
// the header itself, the kendaraan of the url and the problems of the kendaraan.
//   requireTrailer: (config) a trailer is needed when there is no kendaraan (trado)
const useEditorHeaderApi = ({
  uiContext,
  navigate,
  location,
  currentUrl,
  requestGet,
  requestGetOne,
  requestPost,
  headerData,
  setHeaderData,
  setHeaderError,
  setPengecekanPertama,
  setPengecekanData,
  setPengecekanDetilData,
  setPengecekanSaved,
  setListProblemData,
  requireTrailer,
}) => {
  // validation

  const validateHeader = () => {
    let valid = true;
    const newError = {};
    const { data_trailer, data_kendaraan, km } = headerData;

    if ((!data_kendaraan || data_kendaraan.id <= 0) && data_trailer == null) {
      newError["data_kendaraan"] = "Kendaraan harus diisi";
      valid = false;
    }

    if (
      requireTrailer &&
      (!data_trailer || data_trailer.id <= 0) &&
      data_kendaraan == null
    ) {
      newError["data_trailer"] = "Trailer harus diisi";
      valid = false;
    }

    if (!km || km <= 0) {
      newError["km"] = "Kilometer harus > 0";
      valid = false;
    }

    if (!valid) setHeaderError(newError);

    setTimeout(() => {
      setHeaderError();
    }, 5000);

    return valid;
  };

  // API call

  const saveHeader = async () => {
    setHeaderError({});
    const valid = validateHeader();

    if (valid) {
      const body = convertSaveHeader(headerData);

      await requestPost({
        fullUrl: "/api/audit/auditkendaraan/save",
        body,
        isForm: false,
        onError: ({ message, data }) => {
          uiContext.showErrorMsg("Error", message);
        },
        onSuccess: ({ data, message }) => {
          setPengecekanPertama(false);
          fetchProblemMobil({ kendaraanId: data.kendaraan_id });
          uiContext.showSuccessMsg("Success", message);

          // reload front end data
          setHeaderData(convertLoadedHeader(data));
          // navigate to new url
          const isNew = currentUrl.includes("new");
          if (data.id && data.id > 0 && isNew) {
            const urlParams = new URLSearchParams(location.search);
            const key = urlParams.get("key");
            if (key) {
              navigate(`../${data.id}?key=${encodeURIComponent(key)}`);
            } else {
              navigate("../" + data.id);
            }
            fetchHeader(data.id);
          }
        },
      });
    }
  };

  const fetchKendaraanById = ({ kendaraanId }) => {
    if (!kendaraanId) return;

    const filter = `id:=:${kendaraanId}`;

    requestGet({
      fullUrl: "/api/masterdata/kendaraan/data",
      params: {
        take: 1,
        page: 1,
        filter,
        order: "id",
        order_method: "ASC",
        with_kendaraan_grup: 1,
        with_kendaraan_jenis: 1,
        with_kendaraan_pemakaian: 1,
        with_supir_tetap: 1,
        with_services: 1,
      },
      onSuccess: ({ data }) => {
        if (data && data.length > 0) {
          const kendaraan = data[0];
          setHeaderData((prev) => ({
            ...prev,
            kendaraan_id: parseInt(kendaraanId, 10),
            data_kendaraan: kendaraan,
          }));
        } else {
          setHeaderError("Kendaraan tidak ditemukan");
        }
      },
      onError: ({ message }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const fetchProblemMobil = async ({ kendaraanId }) => {
    if (kendaraanId && kendaraanId > 0) {
      const _kendaraanId = kendaraanId ?? headerData.data_kendaraan.id;
      var filter = `tanggal_selesai:=:Null;kendaraan_id:=:${_kendaraanId}`;

      if (headerData.trailer_id && headerData.trailer_id > 0) {
        filter += `||trailer_id:=:${headerData.trailer_id}`;
      }

      return requestGet({
        fullUrl: `/api/problem/problemkendaraan/data`,
        params: {
          page: 1,
          take: 1000,
          filter,
          order: "tanggal",
          order_method: "ASC",
        },
        onSuccess: ({ pagination, message, data }) => {
          setListProblemData(data);
        },
        onError: ({ message, data }) =>
          uiContext.showErrorMsg("Error", message),
      });
    }
  };

  const fetchHeader = async (id) => {
    if (id && id > 0) {
      await requestGetOne({
        fullUrl: `/api/audit/auditkendaraan/one/${id}`,
        onError: ({ message }) => {
          uiContext.showErrorMsg("Error", message);
        },
        onSuccess: ({ data }) => {
          // Fetch problem list related to kendaraan
          fetchProblemMobil({ kendaraanId: data.kendaraan_id });

          // Set default tanggal if missing
          if (!data.tanggal) {
            data.tanggal = new Date();
            setPengecekanPertama(true);
          }

          // Convert and store header
          setHeaderData(convertLoadedHeader(data));

          // the header is the unified detail source
          if (data.data_audit_kendaraan_detils) {
            setPengecekanData(data);

            // Auto-detect if any pengecekan image exists
            setPengecekanDetilData(
              generateUpdatedImagePengecekanMobil(
                data.data_audit_kendaraan_detils
              )
            );
          }

          // Auto-detect bagian checked (grouped by label_grup)
          const pengecekanDetils = data.data_audit_kendaraan_detils || [];

          if (pengecekanDetils.length > 0) {
            const mapChecked = {};
            for (const detil of pengecekanDetils) {
              const labelGroup = detil.label_grup;
              mapChecked[labelGroup] =
                (mapChecked[labelGroup] ?? 0) + (detil.cek ? 1 : 0);
            }

            setPengecekanSaved({
              bagian_depan: mapChecked["bagian_depan"] > 0,
              bagian_samping: mapChecked["bagian_samping"] > 0,
              bagian_belakang: mapChecked["bagian_belakang"] > 0,
              bagian_dalam: mapChecked["bagian_dalam"] > 0,
            });
          }
        },
      });
    }
  };

  return {
    saveHeader,
    fetchKendaraanById,
    fetchProblemMobil,
    fetchHeader,
  };
};

export default useEditorHeaderApi;
